import { useEffect, useState } from 'react';
import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import { SchemaStatuses } from 'constants/schemaStatuses';
import { getDataSheetByCandidateId } from 'UI/pages/EditCandidateDataSheet/EditCandidateDataSheet.services';

/**
 * @param {number} [candidateId]
 */
export const useValidCandidateDataSheet = candidateId => {
  const [candidateDataSheet, setCandidateDataSheet] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!candidateId) return;

      try {
        const response = await getDataSheetByCandidateId(candidateId);

        if (response.status !== HTTPStatusCodes.Ok) return;
        if (response.data?.progress?.key !== SchemaStatuses.Completed) return;

        setCandidateDataSheet(response.data);
      } catch (error) {
        // Nothing to do here
      }
    };

    fetchData();

    return () => {
      setCandidateDataSheet(null);
    };
  }, [candidateId]);

  return {
    candidateDataSheet
  };
};
